import { useTranslation } from 'react-i18next'
import { ALL_NS } from '~/i18n/namespaces'
import { BUTTON_TYPE } from './Button.model'
import { DialogActionProps } from './DialogFooter.model'
import { EFButton } from '~/components/EFButton/EFButton.component'
import { EFFooterDialogWrapper } from '~/components/EFStyledComponents'

export function DialogFooter({
  type,
  onSubmit,
  isLoading,
  disabled,
  buttonPrimaryText,
  buttonSecondaryText
}: DialogActionProps) {
  const { t } = useTranslation(ALL_NS)
  const renderSwitchAction = () => {
    switch (type) {
      case 'ApplyClear':
        return (
          <>
            <EFButton
              sx={{ mr: 1 }}
              className='button-text'
              onClick={() => onSubmit(BUTTON_TYPE.CLEAR)}
            >
              {buttonPrimaryText ?? t('MessageButton_Clear')}
            </EFButton>
            <EFButton
              onClick={() => onSubmit(BUTTON_TYPE.APPLY)}
              isLoading={isLoading}
              disabled={disabled}
            >
              {buttonSecondaryText ?? t('MessageButton_Apply')}
            </EFButton>
          </>
        )
      case 'ApplyReset':
        return (
          <>
            <EFButton
              sx={{ mr: 1 }}
              className='button-text'
              onClick={() => onSubmit(BUTTON_TYPE.RESET)}
            >
              {buttonPrimaryText ?? t('MessageButton_ResetDefault')}
            </EFButton>
            <EFButton
              onClick={() => onSubmit(BUTTON_TYPE.APPLY)}
              isLoading={isLoading}
              disabled={disabled}
            >
              {buttonSecondaryText ?? t('MessageButton_Apply')}
            </EFButton>
          </>
        )
      case 'ApproveCancel':
        return (
          <>
            <EFButton
              sx={{ mr: 1 }}
              className='button-text'
              onClick={() => onSubmit(BUTTON_TYPE.CANCEL)}
            >
              {buttonPrimaryText ?? t('MessageButton_Cancel')}
            </EFButton>
            <EFButton
              onClick={() => onSubmit(BUTTON_TYPE.APPROVE)}
              isLoading={isLoading}
              disabled={disabled}
            >
              {buttonSecondaryText ?? t('Button_Approve')}
            </EFButton>
          </>
        )
      case 'ConfirmCancel':
        return (
          <>
            <EFButton
              sx={{ mr: 1 }}
              className='button-text'
              onClick={() => onSubmit(BUTTON_TYPE.CANCEL)}
            >
              {buttonPrimaryText ?? t('MessageButton_Cancel')}
            </EFButton>
            <EFButton
              onClick={() => onSubmit(BUTTON_TYPE.CONFIRM)}
              isLoading={isLoading}
              disabled={disabled}
            >
              {buttonSecondaryText ?? t('Button_Confirm')}
            </EFButton>
          </>
        )
      case 'CreateCancel':
        return (
          <>
            <EFButton
              sx={{ mr: 1 }}
              className='button-text'
              onClick={() => onSubmit(BUTTON_TYPE.CANCEL)}
            >
              {buttonPrimaryText ?? t('MessageButton_Cancel')}
            </EFButton>
            <EFButton
              onClick={() => onSubmit(BUTTON_TYPE.CREATE)}
              isLoading={isLoading}
              disabled={disabled}
            >
              {buttonSecondaryText ?? t('Button_Create')}
            </EFButton>
          </>
        )
      case 'DeleteCancel':
        return (
          <>
            <EFButton
              sx={{ mr: 1 }}
              className='button-text'
              onClick={() => onSubmit(BUTTON_TYPE.CANCEL)}
            >
              {buttonPrimaryText ?? t('MessageButton_Cancel')}
            </EFButton>
            <EFButton
              onClick={() => onSubmit(BUTTON_TYPE.DELETE)}
              isLoading={isLoading}
              disabled={disabled}
            >
              {buttonSecondaryText ?? t('Button_Delete')}
            </EFButton>
          </>
        )
      case 'DecommissionCancel':
        return (
          <>
            <EFButton
              sx={{ mr: 1 }}
              className='button-text'
              onClick={() => onSubmit(BUTTON_TYPE.CANCEL)}
            >
              {buttonPrimaryText ?? t('MessageButton_Cancel')}
            </EFButton>
            <EFButton
              onClick={() => onSubmit(BUTTON_TYPE.DECOMMISSION)}
              isLoading={isLoading}
              disabled={disabled}
            >
              {buttonSecondaryText ?? t('Button_Decommission')}
            </EFButton>
          </>
        )
      case 'InitiateOTAPCancel':
        return (
          <>
            <EFButton
              sx={{ mr: 1 }}
              className='button-text'
              onClick={() => onSubmit(BUTTON_TYPE.CANCEL)}
            >
              {buttonPrimaryText ?? t('MessageButton_Cancel')}
            </EFButton>
            <EFButton
              onClick={() => onSubmit(BUTTON_TYPE.INITIATE_OTAP)}
              isLoading={isLoading}
              disabled={disabled}
            >
              {buttonSecondaryText ?? t('Button_InitiateOtap')}
            </EFButton>
          </>
        )
      case 'ForceInitiateOtapCancel':
        return (
          <>
            <EFButton
              sx={{ mr: 1 }}
              className='button-text'
              onClick={() => onSubmit(BUTTON_TYPE.CANCEL)}
            >
              {buttonPrimaryText ?? t('MessageButton_Cancel')}
            </EFButton>
            <EFButton
              onClick={() => onSubmit(BUTTON_TYPE.FORCE_INITIATE_OTAP)}
              isLoading={isLoading}
              disabled={disabled}
            >
              {buttonSecondaryText ?? t('Button_InitiateWithUnconditionalActivation')}
            </EFButton>
          </>
        )
      case 'LeaveCancel':
        return (
          <>
            <EFButton
              sx={{ mr: 1 }}
              className='button-text'
              onClick={() => onSubmit(BUTTON_TYPE.CANCEL)}
            >
              {buttonPrimaryText ?? t('MessageButton_Cancel')}
            </EFButton>
            <EFButton
              onClick={() => onSubmit(BUTTON_TYPE.LEAVE)}
              isLoading={isLoading}
              disabled={disabled}
            >
              {buttonSecondaryText ?? t('Button_Leave')}
            </EFButton>
          </>
        )
      case 'OkCancel':
        return (
          <>
            <EFButton
              sx={{ mr: 1 }}
              className='button-text'
              onClick={() => onSubmit(BUTTON_TYPE.CANCEL)}
            >
              {buttonPrimaryText ?? t('MessageButton_Cancel')}
            </EFButton>
            <EFButton
              onClick={() => onSubmit(BUTTON_TYPE.OK)}
              isLoading={isLoading}
              disabled={disabled}
            >
              {buttonSecondaryText ?? t('MessageButton_OK_')}
            </EFButton>
          </>
        )
      case 'SaveCancel':
        return (
          <>
            <EFButton
              sx={{ mr: 1 }}
              className='button-text'
              onClick={() => onSubmit(BUTTON_TYPE.CANCEL)}
            >
              {buttonPrimaryText ?? t('MessageButton_Cancel')}
            </EFButton>
            <EFButton
              onClick={() => onSubmit(BUTTON_TYPE.SAVE)}
              isLoading={isLoading}
              disabled={disabled}
            >
              {buttonSecondaryText ?? t('Button_Save')}
            </EFButton>
          </>
        )
      case 'YesNo':
        return (
          <>
            <EFButton
              sx={{ mr: 1 }}
              className='button-text'
              onClick={() => onSubmit(BUTTON_TYPE.NO)}
            >
              {buttonPrimaryText ?? t('Button_No')}
            </EFButton>
            <EFButton
              onClick={() => onSubmit(BUTTON_TYPE.YES)}
              isLoading={isLoading}
              disabled={disabled}
            >
              {buttonSecondaryText ?? t('Button_Yes')}
            </EFButton>
          </>
        )
      case 'ObsoleteCancel':
        return (
          <>
            <EFButton
              sx={{ mr: 1 }}
              className='button-text'
              onClick={() => onSubmit(BUTTON_TYPE.CANCEL)}
            >
              {buttonPrimaryText ?? t('MessageButton_Cancel')}
            </EFButton>
            <EFButton
              onClick={() => onSubmit(BUTTON_TYPE.OBSOLETE)}
              isLoading={isLoading}
              disabled={disabled}
            >
              {buttonSecondaryText ?? t('Button_Obsolete')}
            </EFButton>
          </>
        )
      case 'Close':
        return (
          <EFButton onClick={() => onSubmit(BUTTON_TYPE.CLOSE)}>
            {buttonPrimaryText ?? t('Button_Close')}
          </EFButton>
        )
      case 'Cancel':
        return (
          <EFButton
            className='button-text'
            onClick={() => onSubmit(BUTTON_TYPE.CANCEL)}
          >
            {buttonPrimaryText ?? t('MessageButton_Cancel')}
          </EFButton>
        )
      default:
        return null
    }
  }
  return <EFFooterDialogWrapper>{renderSwitchAction()}</EFFooterDialogWrapper>
}
